module.exports = __webpack_public_path__ + "static/media/feedback-left-wireframe.c0f7ca12.svg";